export type VimtutorRawType = {
  id: string;
  exerciseId: number;
  section: string;
  title: string;
  instructions: string;
  initialState: string;
  desiredState: string;
  type: "EDITING" | "NAVIGATION" | "BOTH";
  desiredCursorPosition?: number;
  difficulty: string;
  tagIds: string[];
  motions: { motion: string; explanation: string }[];
};

const SECTION_1: VimtutorRawType[] = [
  {
    section: "1",
    id: "vimtutor-1.1",
    exerciseId: 1,
    title: "Lesson 1.1: Moving the Cursor",
    instructions: "Use the h, j, k, l keys to move the cursor as directed.",
    initialState:
      "Navigate to the third line\nUsing h,j,k, and l. \nMove your cursor here ->.\nIf you scrolled all the way down here, you went too far.",
    desiredState:
      "Navigate to the third line\nUsing h,j,k, and l. \nMove your cursor here ->.\nIf you scrolled all the way down here, you went too far.",
    difficulty: "Beginner",
    tagIds: ["tag-movement"],
    type: "NAVIGATION",
    desiredCursorPosition: 72,
    motions: [
      { motion: "h", explanation: "Move cursor left." },
      { motion: "j", explanation: "Move cursor down." },
      { motion: "k", explanation: "Move cursor up." },
      { motion: "l", explanation: "Move cursor right." },
    ],
  },
  {
    section: "1",
    exerciseId: 2,
    id: "vimtutor-1.2",
    title: "Lesson 1.2: Text Editing - Deletion",
    instructions: "Press x to delete the character under the cursor.",
    initialState: "The ccow jumpedd ovverr thhe mooon.",
    type: "EDITING",
    desiredCursorPosition: undefined,
    desiredState: "The cow jumped over the moon.",
    difficulty: "Beginner",
    tagIds: ["tag-commands"],
    motions: [{ motion: "x", explanation: "Delete character under cursor." }],
  },
  {
    section: "1",
    exerciseId: 3,
    id: "vimtutor-1.3",
    title: "Lesson 1.3: Text Editing - Inserting and Appending",
    instructions:
      "Press  i, or a  to insert text. Use the Esc key to exit insert mode.",
    initialState: "There is text misng this .",
    type: "EDITING",
    desiredCursorPosition: undefined,
    desiredState: "There is some text missing from this line.",
    difficulty: "Beginner",
    tagIds: ["tag-commands"],
    motions: [
      { motion: "i", explanation: "Insert before cursor." },
      { motion: "a", explanation: "Append after cursor." },
      { motion: "Esc", explanation: "Exit insert mode." },
    ],
  },
];

const SECTION_2: VimtutorRawType[] = [
  {
    id: "vimtutor-2.1",
    exerciseId: 4,
    section: "2",
    title: "Lesson 2.1: Deleting words",
    instructions: "Type dw to delete a word.",
    initialState:
      "There are a some words fun that don't belong paper in this sentence.",
    desiredState: "There are some words that don't belong in this sentence.",
    difficulty: "Beginner",
    tagIds: ["tag-deletion"],
    type: "EDITING",
    motions: [
      { motion: "d", explanation: "Delete." },
      { motion: "w", explanation: "Word." },
      { motion: "dw", explanation: "Delete word." },
      { motion: "Esc", explanation: "Exit insert mode." },
    ],
  },
  {
    id: "vimtutor-2.2",
    exerciseId: 5,
    section: "2",
    title: "Lesson 2.2: More Deletion Commands",
    instructions: "Type  d$  to delete to the end of the line..",
    initialState:
      "Somebody typed the end of this line twice. end of this line twice.",
    desiredState: "Somebody typed the end of this line twice.",
    difficulty: "Beginner",
    tagIds: ["tag-deletion"],
    type: "EDITING",
    motions: [
      { motion: "d", explanation: "Delete." },
      { motion: "$", explanation: "End of line." },
      { motion: "d$", explanation: "Delete to end of line." },
      { motion: "Esc", explanation: "Exit insert mode." },
    ],
  },
  {
    id: "vimtutor-2.3",
    exerciseId: 6,
    section: "2",
    title: "Lesson 2.3: Using a Count to Delete More",
    instructions: `Typing a number before a motion repeats it that many times.
    1. Type  d2w  to delete the two UPPER CASE words.
    2. Repeat with a different count to delete the consecutive UPPER CASE words with one command.
    `,
    initialState:
      "this ABC DE line FGHI JK LMN OP of words is Q RS TUV cleaned up.",
    desiredState: "this line of words is cleaned up.",
    difficulty: "Beginner",
    tagIds: ["tag-insertion"],
    type: "EDITING",
    motions: [{ motion: "d<N>w", explanation: "Delete N words." }],
  },
  {
    id: "vimtutor-2.4",
    exerciseId: 7,
    section: "2",
    title: "Lesson 2.4: Operating on Lines",
    instructions: "Type  dd to delete a whole line.",
    initialState: `1)  Roses are red,\n2)  Mud is fun,\n3)  Violets are blue,\n4)  I have a car,\n5)  Clocks tell time,\n6)  Sugar is sweet\n7)  And so are you.`,
    desiredState:
      "1)  Roses are red,\n3)  Violets are blue,\n6)  Sugar is sweet\n7)  And so are you.",
    difficulty: "Beginner",
    tagIds: ["tag-insertion"],
    type: "EDITING",
    motions: [{ motion: "d<N>w", explanation: "Delete N words." }],
  },
];

const SECTION_3: VimtutorRawType[] = [
  {
    id: "vimtutor-3.1",
    exerciseId: 8,
    section: "3",
    title: "Lesson 3.1: The PUT Command",
    instructions: `Type  p, or P  to put previously deleted text after the cursor.
  1. Move the cursor to the first line.
  2. Type  dd  to delete the line and store it in a Vim register.
  3. Move the cursor to the c) line, ABOVE where the deleted line should go.
  4. Type   p   to put the line below the cursor.
  5. Repeat steps 2 through 4 to put all the lines in correct order.`,
    initialState:
      "d) Can you learn too?\nb) Violets are blue,\nc) Intelligence is learned,\na) Roses are red,",
    desiredState:
      "a) Roses are red,\nb) Violets are blue,\nc) Intelligence is learned,\nd) Can you learn too?",
    difficulty: "Intermediate",
    tagIds: ["tag-deletion"],
    type: "EDITING",
    motions: [
      { motion: "p", explanation: "Put deleted text after cursor." },
      { motion: "P", explanation: "Put deleted text before cursor." },
      { motion: "dd", explanation: "Delete line." },
    ],
  },
  {
    id: "vimtutor-3.2",
    exerciseId: 9,
    section: "3",
    title: "Lesson 3.2: The Replace Command",
    instructions:
      "Type  rx  to replace the character at the cursor with  x .\n 1. Move the cursor so that it is on top of the first error.\n  2. Type  r  and then the character which should be there.\n  3. Repeat steps until the first line is equal to the desired state.",
    initialState:
      "Whan this lime was tuoed in, someone presswd some wrojg keys!\n\n",
    desiredState:
      "When this line was typed in, someone pressed some wrong keys!\n\n",
    difficulty: "Beginner",
    tagIds: ["tag-editing"],
    type: "EDITING",
    motions: [{ motion: "r", explanation: "Replace character under cursor." }],
  },

  {
    id: "vimtutor-3.3",
    exerciseId: 10,
    section: "3",
    title: "Lesson 3.3: The Change Operator",
    instructions:
      "Type  ce  to change until the end of a word.\n 1. Move the cursor to the first line.\n  2. Place the cursor on the  u  in  lubw.\n  3. Type  ce  and the correct word (in this case, type  ine ).\n  4. Press <ESC> and move to the next character that needs to be changed.\n  5. Repeat steps 3 and 4 until the first sentence is the same as the second.",
    initialState:
      "This lubw has a few wptfd that mrrf changing usf the change operator.",
    desiredState:
      "This line has a few words that need changing using the change operator.",
    difficulty: "Intermediate",
    tagIds: ["tag-substitution"],
    type: "EDITING",
    motions: [
      { motion: "ce", explanation: "Change until end of word." },
      { motion: "<ESC>", explanation: "Exit insert mode." },
    ],
  },

  {
    id: "vimtutor-3.4",
    exerciseId: 10,
    section: "3",
    title: "Lesson 3.4: More Changes Using c",
    instructions:
      "The change operator is used with the same motions as delete. **\n1. The change operator works in the same way as delete.  The format is:\n c    [number]   motion\n2. The motions are the same, such as   w (word) and  $ (end of line).\n3. Move the cursor to the first line below marked --->.\n4. Move the cursor to the first error.\n5. Type  c$  and type the rest of the line like the second and press <ESC>.",
    initialState:
      "The end of this line needs some help to make it like the second.",
    desiredState:
      "The end of this line needs to be corrected using the  c$  command..",
    difficulty: "Intermediate",
    tagIds: ["tag-substitution"],
    type: "EDITING",
    motions: [
      { motion: "c", explanation: "Change." },
      { motion: "$", explanation: "End of line." },
      { motion: "c$", explanation: "Change to end of line." },
    ],
  },
];

const SECTION_4: VimtutorRawType[] = [
  {
    id: "vimtutor-4.1",
    exerciseId: 11,
    section: "4",
    title: "Lesson 4.1: The Search Command",
    instructions:
      "Type  /  followed by a phrase to search for the phrase.\n 1. In Normal mode type the  /  character.  Notice that it and the cursor\n appear at the bottom of the screen as with the  :  command.\n 2. Now type 'errroor' <ENTER>.  This is the word you want to search for.\n 3. To search for the same phrase again, simply type  n .\n    To search for the same phrase in the opposite direction, type  N .\n 4. To search for a phrase in the backward direction, use  ?  instead of  / .\n 5. To go back to where you came from press  CTRL-O  (Keep Ctrl down while\n    pressing the letter o).  Repeat to go back further.  CTRL-I goes forward.\n6. To finish the exercise, just navigate to the second 'errroor'.",
    initialState:
      '"errroor" is not the way to spell error;  errroor is an error.',
    desiredState:
      '"errroor" is not the way to spell error;  errroor is an error.',
    difficulty: "Intermediate",
    desiredCursorPosition: 42,
    tagIds: ["tag-substitution"],
    type: "NAVIGATION",
    motions: [
      { motion: "c", explanation: "Change." },
      { motion: "$", explanation: "End of line." },
      { motion: "c$", explanation: "Change to end of line." },
    ],
  },

  {
    id: "vimtutor-4.2",
    exerciseId: 12,
    section: "4",
    title: "Lesson 4.2: Matching Parentheses Searching",
    instructions:
      "Type  %  to find a matching ),], or } .\n 1. Place the cursor on any (, [, or { in the line below.\n 2. Now type the  %  character.\n 3. The cursor will move to the matching parenthesis or bracket.\n 4. Type  %  to move the cursor to the other matching bracket.\n 5. Move the cursor to another (,),[,],{ or } and see what  %  does.",
    initialState: "This ( is a test line with ('s, ['s ] and {'s } in it. ))",
    desiredState: "This ( is a test line with ('s, ['s ] and {'s } in it. ))",
    difficulty: "Intermediate",
    desiredCursorPosition: -1,
    tagIds: ["tag-navigation"],
    type: "NAVIGATION",
    motions: [{ motion: "%", explanation: "Find a matching ),], or }." }],
  },

  {
    id: "vimtutor-4.3",
    exerciseId: 13,
    section: "4",
    title: "Lesson 4.2: The Substitute Command",
    instructions:
      "Type  :s/old/new/g  to substitute 'new' for 'old'.\n 1. Move the cursor to the first line.\n 2. Type  :s/thee/the <ENTER> .  Note that this command only changes the first occurrence of 'thee' in the line.\n 3. Now type  :s/thee/the/g .  Adding the  g  flag means to substitute globally in the line, change all occurrences of 'thee' in the line.",
    initialState: "thee best time to see thee flowers is in thee spring.",
    desiredState: "the best time to see the flowers is in the spring.",
    difficulty: "Intermediate",
    tagIds: ["tag-editing"],
    type: "EDITING",
    motions: [
      {
        motion: ":s/old/new/",
        explanation: "Substitute first ocurrence of 'new' for 'old'.",
      },
      {
        motion: ":s/old/new/g",
        explanation: "Global Substitute 'new' for 'old'.",
      },
    ],
  },
];

const SECTION_5: VimtutorRawType[] = [
  {
    id: "vimtutor-5.1",
    exerciseId: 14,
    section: "5",
    title: "Lesson 5.1: The Open Command",
    instructions:
      "Type o  to open a line below the cursor and place you in Insert mode.\n 1. Move the cursor to the first line.\n 2. Type the lowercase letter  o  to open up a line BELOW the cursor and place you in Insert mode.\n 3. Now type some text and press <ESC> to exit Insert mode.\n 4. To open up a line ABOVE the cursor, simply type a capital  O , rather than a lowercase  o.",
    initialState:
      "1.Type O to open a line above this one.\n2. Type o to open a line below this one.",
    desiredState:
      "\n1.Type O to open a line above this one.\n2. Type o to open a line below this one.\n",
    difficulty: "Intermediate",
    tagIds: ["tag-editing"],
    type: "EDITING",
    motions: [
      { motion: "o", explanation: "Open line below cursor." },
      { motion: "O", explanation: "Open line above cursor." },
    ],
  },

  {
    id: "vimtutor-5.2",
    exerciseId: 15,
    section: "5",
    title: "Lesson 5.2: Another Way To Replace",
    instructions:
      "Type a capital  R  to replace more than one character.\n 1. Move the cursor to the first line.  Move the cursor to the beginning of the first  xxx .\n 2. Now press  R  and type the number below it in the second line, so that it replaces the xxx .\n 3. Press <ESC> to leave Replace mode.  Notice that the rest of the line remains unmodified.\n 4. Repeat the steps to replace the remaining xxx.",
    initialState: "Adding 123 to xxx gives you xxx.",
    desiredState: "Adding 123 to 456 gives you 579.",
    difficulty: "Intermediate",
    tagIds: ["tag-editing"],
    type: "EDITING",
    motions: [{ motion: "R", explanation: "Replace multiple characters." }],
  },
  {
    id: "vimtutor-5.3",
    exerciseId: 16,
    section: "5",
    title: "Lesson 5.3: Copy And Paste Text",
    instructions:
      "Use the  y  operator to copy text and  p  to paste it **\n 1. Move to the line below and place the cursor after 'a)'.\n 2. Start Visual mode with  v  and move the cursor to just before 'first'.\n 3. Type  y  to yank (copy) the highlighted text.\n 4. Move the cursor to the end of the next line:  j$\n 5. Type  p  to put (paste) the text.  Then type:  a second <ESC> .\n 6. Use Visual mode to select ' item.', yank it with",
    initialState: "a) this is the first item.\nb)",
    desiredState: "a) this is the first item.\nb) this is the second item.",
    difficulty: "Intermediate",
    tagIds: ["tag-editing"],
    type: "EDITING",
    motions: [
      { motion: "y", explanation: "Yank (copy) text." },
      { motion: "p", explanation: "Put (paste) text." },
      { motion: "j$", explanation: "Move cursor to end of line." },
      { motion: "<ESC>", explanation: "Exit insert mode." },
    ],
  },
];

export const VIMTUTOR_RAW: VimtutorRawType[] = [
  ...SECTION_1,
  // SECTION 2
  ...SECTION_2,
  ...SECTION_3,
  // SECTION 4
  ...SECTION_4,
  // SECTION 5
  ...SECTION_5,
];
